// extracted by mini-css-extract-plugin
export default {"input":"input-module--input--518c3"};